// package: profile
// file: profile.proto

var profile_pb = require("./profile_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var Profile = (function () {
  function Profile() {}
  Profile.serviceName = "profile.Profile";
  return Profile;
}());

Profile.GetProfile = {
  methodName: "GetProfile",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.ProfileGetRequest,
  responseType: profile_pb.ProfileGetReply
};

Profile.GetPendingInvitation = {
  methodName: "GetPendingInvitation",
  service: Profile,
  requestStream: false,
  responseStream: true,
  requestType: profile_pb.ProfileGetPendingInvitationRequest,
  responseType: profile_pb.ProfileGetPendingInvitationReply
};

Profile.AcceptInvitation = {
  methodName: "AcceptInvitation",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.ProfileAcceptInvitationRequest,
  responseType: profile_pb.ProfileAcceptInvitationReply
};

Profile.Update = {
  methodName: "Update",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.ProfileUpdateRequest,
  responseType: profile_pb.ProfileUpdateReply
};

Profile.AddEmail = {
  methodName: "AddEmail",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.ProfileAddEmailRequest,
  responseType: profile_pb.ProfileAddEmailReply
};

Profile.SetEmailAsPrimary = {
  methodName: "SetEmailAsPrimary",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.ProfileSetEmailAsPrimaryRequest,
  responseType: profile_pb.ProfileSetEmailAsPrimaryReply
};

Profile.DeleteEmail = {
  methodName: "DeleteEmail",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.ProfileDeleteEmailRequest,
  responseType: profile_pb.ProfileDeleteEmailReply
};

Profile.GetUserToken = {
  methodName: "GetUserToken",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.GetUserTokenRequest,
  responseType: profile_pb.GetUserTokenReply
};

Profile.GetUserFontendParameters = {
  methodName: "GetUserFontendParameters",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.GetUserFontendParametersRequest,
  responseType: profile_pb.GetUserFontendParametersReply
};

Profile.SetUserFontendParameters = {
  methodName: "SetUserFontendParameters",
  service: Profile,
  requestStream: false,
  responseStream: false,
  requestType: profile_pb.SetUserFontendParametersRequest,
  responseType: profile_pb.SetUserFontendParametersReply
};

exports.Profile = Profile;

function ProfileClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

ProfileClient.prototype.getProfile = function getProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.GetProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.getPendingInvitation = function getPendingInvitation(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Profile.GetPendingInvitation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

ProfileClient.prototype.acceptInvitation = function acceptInvitation(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.AcceptInvitation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.update = function update(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.Update, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.addEmail = function addEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.AddEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.setEmailAsPrimary = function setEmailAsPrimary(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.SetEmailAsPrimary, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.deleteEmail = function deleteEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.DeleteEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.getUserToken = function getUserToken(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.GetUserToken, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.getUserFontendParameters = function getUserFontendParameters(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.GetUserFontendParameters, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ProfileClient.prototype.setUserFontendParameters = function setUserFontendParameters(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Profile.SetUserFontendParameters, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.ProfileClient = ProfileClient;

